import { MATTER_SCALE, SLIT_COMBINE_BODY_LABEL, SLIT_DIVIDE_BODY_LABEL } from '@/features/experience/misc/constants'

import { Bodies, Body, Composite, World } from 'matter-js'
import RoomPhysics, { CollisionCategory, CollisionGroup } from '../room-physics-base'

const SLIT_HEIGHT = 660
const SLIT_EDGE_HEIGHT = 70
const wallWidth = 240
export default class RoomPhysicsCustomizedWallet extends RoomPhysics {
  #leftWallEdges: Body = {} as Body
  #rightWallEdges: Body = {} as Body
  #leftSlitBlocker: Body = {} as Body
  #rightSlitBlocker: Body = {} as Body
  #floorSlitDisabler: Body = {} as Body
  #topGroup: Composite = {} as Composite
  #bottomGroup: Composite = {} as Composite
  #topBlocker: Body = {} as Body
  #topSensor: Body = {} as Body
  #topGroupY = 0

  constructor() {
    super()
  }

  createSideWalls(): Body[] {
    //const colliders = this.createTopGroup()
    this.createBottomGroup()

    //return [...colliders]
    return []
  }

  createTopGroup(): Body[] {
    const sideWidth = 4000
    const tubeWidth = 440
    const tubeHeight = 600
    const topEdge = -1000
    const tubeUpperEdgeHeight = 200

    const topTubeLeft = Bodies.rectangle(
      -tubeWidth * 0.5 - sideWidth * 0.5,
      topEdge - tubeHeight * 0.5,
      sideWidth,
      tubeHeight,
      {
        label: 'topleft',
        isStatic: true,
        collisionFilter: {
          group: CollisionGroup.NoCoins,
          category: CollisionCategory.StaticWallsFront,
          mask: CollisionCategory.Coins
        }
      }
    )

    const topTubeRight = Bodies.rectangle(
      tubeWidth * 0.5 + sideWidth * 0.5,
      topEdge - tubeHeight * 0.5,
      sideWidth,
      tubeHeight,
      {
        isStatic: true,
        collisionFilter: {
          group: CollisionGroup.NoCoins,
          category: CollisionCategory.StaticWallsFront,
          mask: CollisionCategory.Coins
        }
      }
    )

    const topTubeUpperEdge = Bodies.rectangle(
      0,
      topEdge - tubeHeight - tubeUpperEdgeHeight * 0.5,
      tubeWidth,
      tubeUpperEdgeHeight,
      {
        isStatic: true,
        collisionFilter: {
          group: CollisionGroup.NoCoins,
          category: CollisionCategory.StaticWallsFront,
          mask: CollisionCategory.Coins
        }
      }
    )

    this.#topBlocker = Bodies.rectangle(0, topEdge - tubeUpperEdgeHeight * 0.5 + 10, tubeWidth, tubeUpperEdgeHeight, {
      isStatic: true,
      collisionFilter: {
        group: CollisionGroup.ActiveCoins,
        category: CollisionCategory.StaticWallsFront,
        mask: CollisionCategory.Coins
      }
    })

    const topDragBlocker = Bodies.rectangle(
      0,
      topEdge - tubeUpperEdgeHeight * 0.5 + 10,
      tubeWidth,
      tubeUpperEdgeHeight,
      {
        render: { fillStyle: 'red' },
        isStatic: true,
        collisionFilter: {
          group: CollisionGroup.NoCoins,
          category: CollisionCategory.SlitBlockers,
          mask: CollisionCategory.Coins
        }
      }
    )

    this.#topSensor = Bodies.rectangle(0, topEdge - tubeHeight * 0.5, tubeWidth * 0.8, tubeHeight, {
      label: 'slit_top',
      isStatic: true,
      isSensor: true,
      render: { fillStyle: 'yellow' },
      collisionFilter: {
        group: CollisionGroup.NoCoins,
        category: CollisionCategory.StaticWallsFront,
        mask: CollisionCategory.StaticWallsFront
      }
    })

    this.slitSensors.push(this.#topSensor)

    this.#topGroup = Composite.create()
    Composite.add(this.#topGroup, [
      topTubeLeft,
      topTubeRight,
      topTubeUpperEdge,
      this.#topSensor,
      this.#topBlocker,
      topDragBlocker
    ])

    World.add(this.engine.world, [this.#topGroup])
    this.updateTopGroupPosition(5)
    this.disableTopSensor()

    return [topTubeLeft]
  }

  createBottomGroup(): Body[] {
    const bottom = Bodies.rectangle(0, 250, 3000, 400, {
      isStatic: true,
      label: 'bottom_center',
      collisionFilter: {
        group: CollisionGroup.NoCoins,
        category: CollisionCategory.StaticWallsBack,
        mask: CollisionCategory.Coins
      }
    })

    const bottomActiveCoins = Bodies.rectangle(0, 250, 3000, 400, {
      isStatic: true,
      label: 'bottom_center',
      collisionFilter: {
        group: CollisionGroup.NoCoins,
        category: CollisionCategory.StaticWallsFront,
        mask: CollisionCategory.Coins
      }
    })

    this.#bottomGroup = Composite.create()
    Composite.add(this.#bottomGroup, [bottom, bottomActiveCoins])

    World.add(this.engine.world, [this.#bottomGroup])

    return [bottom]
  }

  updateTopGroupPosition(y: number) {
    /*const prevY = this.#topGroupY
    this.#topGroupY = y * -50
    Composite.translate(this.#topGroup, { x: 0, y: -(prevY - this.#topGroupY) })
    */
  }

  enableTopSensor() {
    /*this.#topSensor.isSensor = true
    this.#topBlocker.isSensor = true
    this.#topBlocker.collisionFilter.category = CollisionCategory.None
    */
  }

  disableTopSensor() {
    /*this.#topSensor.isSensor = false
    this.#topBlocker.isSensor = false
    this.#topBlocker.collisionFilter.category = CollisionCategory.Coins
    */
  }
}
